function n(e) {
  return document.getElementById(e) || ((t) => (t.setAttribute("id", e), document.body.appendChild(t)))(document.createElement("div"));
}
export {
  n as getOrCreatePortalElement
};
